const deviceTypes = {
  DESKTOP: 'Desktop Device',
  MOBILE: 'Mobile Device',
}

export default deviceTypes
